import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateCourtCase(item) {
  return client.post("Courts/CreateCourtCase", prepareDataRequest(item));
}

function UpdateCourtCase(item) {
  return client.post("Courts/UpdateCourtCase", prepareDataRequest(item));
}

function GetCourtCases(subrogationId) {
  return client.post("Courts/GetCourtCases", prepareRequest({ subrogationId }));
}

function LastCourtCaseStatus(courtCaseId) {
  return client.post("Courts/LastCourtCaseStatus", prepareRequest({ id: courtCaseId }));
}


export{
    CreateCourtCase,
    UpdateCourtCase,
    GetCourtCases,
    LastCourtCaseStatus
}